const state = {
  appSelectCoverImgModalVisible: false,
};

const getters = {};
const mutations = {
  setData(state, { key, value }) {
    state[key] = value;
  },
  setDataModal(state, { key, value }) {
    state[key] = value;
  },
};
const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
